import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { RoleGuardService } from '../security/role-guard.service';
import { OktaAuthService } from '@okta/okta-angular';
import { from } from 'rxjs/observable/from';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(public roleGuardService: RoleGuardService,public oktaAuth: OktaAuthService, public router: Router) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return from(this.addAuthenticationToken(request)).pipe(
            switchMap(modifiedRequest => next.handle(modifiedRequest))
        );
    }

    private async addAuthenticationToken(request: HttpRequest<any>): Promise<HttpRequest<any>> {
        const token = await this.oktaAuth.getAccessToken();
        if (!token ) {
            localStorage.clear();
            this.router.navigateByUrl('login');
        }
        const headers = {
            'x-access-token': `Bearer ${token}`,
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
            'Cache-Control': 'no-cache'
        };

        if (request.url.includes('multipart')) {
            return request.clone({
                setHeaders: {
                    ...headers,
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
        return request.clone({
            setHeaders: headers
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/security/token.interceptor.ts